import { buildFilter } from '../utils/sqlUtils';
import ColorConstants from '../../../defaults/ColorConstants';

const FilterPreviewer = (options) => {
  const sql = options => {
    return buildFilter(options, false);
  };

  return (
    <div>
      <pre style={{ whiteSpace: 'pre-line', color: `${ColorConstants.SQLColors.sqlText}` }}>{sql(options)}</pre>
    </div>
  );
};

export default FilterPreviewer;
